import styled from '@emotion/styled'
import {
  Loading,
  PasswordInput,
  TableCell,
  Theme,
} from '@yuno/design-system-web'
import { Grid } from '@yuno/design-system-web'

export const CardKey = styled(Grid)<{
  children: JSX.Element | JSX.Element[]
  theme?: Theme
}>`
  display: flex;
  background: ${({ theme }) => theme.palette.neutral.white[0]};
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 4px;
  margin-top: 20px;
  flex-flow: column;
  padding: 24px;

  & .MuiTable-root {
    display: none;
    border-top: 1px solid rgb(236, 239, 242);
    border-radius: 8px;
    border-left: 1px solid rgb(236, 239, 242);
    border-right: 1px solid rgb(236, 239, 242);
  }

  @media (min-width: 1023px) {
    & .MuiTable-root {
      display: table;
    }
  }
`

export const TipWrapper = styled('div')`
  display: flex;
  padding-top: 32px;
`

export const TextContent = styled('div')`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
`

export const IconWrapper = styled('div')<{
  theme?: Theme
}>`
  display: flex;

  @media (max-width: 1022px) {
    padding: 8px;
    justify-content: space-between;

    & .IconText {
      font-size: ${({ theme }) => theme.typography.small.regular.fontSize};
      color: ${({ theme }) => theme.palette.grey[5]};
    }
  }

  & span {
    margin-left: 8px;
    margin-right: 32px;
  }
`

export const IconContent = styled('div')<{
  theme?: Theme
  disabled?: boolean
}>`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    `
      color: gray;
      cursor: default;
    `}
`

export const CardMobile = styled('div')<{
  theme?: Theme
}>`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 8px;
  margin-bottom: 16px;

  @media (min-width: 1023px) {
    display: none;
  }

  &:last-child {
    margin-bottom: 0;
  }
`

export const RowCardMobile = styled('span')<{
  theme?: Theme
}>`
  margin-inline: 8px;
  padding: 16px 8px;
  color: ${({ theme }) => theme.palette.neutral.black};
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[2]};
`

export const SuccessTitle = styled.span(({ theme }: { theme?: Theme }) => ({
  ...theme.typography.base.bold,
  color: theme.palette.neutral.black,
  margin: `10px 0`,
}))

export const SuccessSubtitle = styled.span(({ theme }: { theme?: Theme }) => ({
  ...theme.typography.tiny.regular,
  color: theme.palette.grey['5'],
  margin: '0px 30px',
  textAlign: 'center',
}))

export const SpanValue = styled('div')<{
  theme?: Theme
}>`
  --custom-word-wrap: anywhere;
  word-wrap: var(--custom-word-wrap);
  margin-block: 16px
  font-size: ${({ theme }) => theme.typography.small.regular.fontSize};
  color: ${({ theme }) => theme.palette.grey[5]};
  font-weight: ${({ theme }) => theme.typography.small.regular.fontWeight};
`

export const TableCellStyled = styled(TableCell)<{
  height?: string
  theme?: Theme
}>`
  height: ${({ height }) => height};
`

export const SpanDialogPassoword = styled.span(
  ({ theme }: { theme?: Theme }) => ({
    ...theme.typography.base.regular,
    color: theme.palette.neutral.black,
    margin: `10px 0`,
  }),
)

export const TitleDialog = styled.span(({ theme }: { theme?: Theme }) => ({
  ...theme.typography.xl.bold,
  color: theme.palette.neutral.black,
  margin: `10px 0`,
}))

export const InputStyled = styled(PasswordInput)`
  padding-top: 20px;
  padding-bottom: 10px;
  .MuiButtonBase-root.MuiIconButton-root {
    right: 25px;
    bottom: 6px;
  }
`

export const SpanStyled = styled.span(
  ({ theme, disabled }: { theme?: Theme; disabled: boolean }) => ({
    color: disabled ? theme.palette.grey[3] : theme.palette.grey[5],
  }),
)

export const LoadingWrapper = styled.div`
  padding-inline: 15px;
  padding-top: 5px;
`
